import type { Messages } from './en.ts';

// Русские тексты. Набор ключей совпадает с en.ts — это проверяет и тип, и тест.
export const ru: Messages = {
  app: { name: 'Form Platform' },
  common: {
    save: 'Сохранить',
    saving: 'Сохраняем…',
    cancel: 'Отмена',
    create: 'Создать',
    delete: 'Удалить',
    edit: 'Изменить',
    close: 'Закрыть',
    copy: 'Копировать',
    copied: 'Скопировано',
    loading: 'Загрузка…',
    add: 'Добавить',
    remove: 'Убрать',
    back: 'Назад',
    yes: 'Да',
    no: 'Нет',
    none: 'Нет',
    name: 'Название',
    actions: 'Действия',
    saved: 'Сохранено.',
    retry: 'Повторить',
    optional: 'необязательно',
    never: 'никогда',
    all: 'Все',
    more: 'Показать ещё',
    confirmDelete: 'Удалить',
    loadFailed: 'Не удалось загрузить.',
  },
  locale: { label: 'Язык', en: 'English', ru: 'Русский' },
  theme: { label: 'Тема', light: 'Светлая', dark: 'Тёмная' },
  errors: {
    generic: 'Что-то пошло не так. Попробуйте ещё раз.',
    forbidden: 'Ваша роль этого не позволяет.',
    notFound: 'Такого объекта нет или у вас нет к нему доступа.',
    network: 'Сервер недоступен. Проверьте соединение и попробуйте ещё раз.',
  },
  auth: {
    signIn: 'Войти',
    signUp: 'Создать учётную запись',
    signOut: 'Выйти',
    email: 'Электронная почта',
    password: 'Пароль',
    newPassword: 'Новый пароль',
    yourName: 'Ваше имя',
    passwordHint: 'Не менее 10 символов.',
    signInTitle: 'Вход в учётную запись',
    signUpTitle: 'Создание учётной записи',
    noAccount: 'Ещё нет учётной записи?',
    haveAccount: 'Уже есть учётная запись?',
    forgot: 'Забыли пароль?',
    forgotTitle: 'Сброс пароля',
    forgotIntro: 'Укажите адрес, с которым вы регистрировались. Мы отправим ссылку для выбора нового пароля.',
    forgotSend: 'Отправить ссылку',
    forgotSent: 'Если учётная запись с таким адресом существует, ссылка уже в пути. Она действует один час.',
    resetTitle: 'Новый пароль',
    resetDone: 'Пароль изменён. Войдите с новым паролем.',
    resetBadLink: 'Ссылка больше не действует. Запросите новую.',
    signInFailed: 'Неверный адрес или пароль.',
    signUpFailed: 'Не удалось создать учётную запись.',
    verifiedTitle: 'Адрес подтверждён',
    verifiedIntro: 'Теперь можно создавать формы.',
    continue: 'Продолжить',
    verifyBanner: 'Подтвердите адрес почты, чтобы создавать формы. Мы отправили ссылку на {email}.',
    verifyResend: 'Отправить ещё раз',
    verifyResent: 'Новая ссылка уже в пути.',
    inviteTitle: 'Вас пригласили',
    inviteIntro: '{inviter} приглашает вас в {organization} с ролью «{role}».',
    inviteAccept: 'Принять и открыть',
    inviteSignInFirst: 'Войдите или создайте учётную запись с адресом {email}, чтобы принять приглашение.',
    inviteInvalid: 'Приглашение недействительно: оно могло истечь, быть отозвано или предназначаться другому адресу.',
    inviteNeedsVerified: 'Сначала подтвердите адрес почты, затем снова откройте ссылку из приглашения.',
    inviteSignInOnly: 'Войдите с адресом, на который пришло приглашение.',
    inviteCreateIntro: 'Создайте учётную запись, чтобы принять приглашение. Входить вы будете с адресом, на который оно пришло.',
    inviteCreate: 'Создать учётную запись',
    inviteAccountExists: 'У этого адреса уже есть учётная запись. Войдите, чтобы принять приглашение.',
    closedHint: 'Учётные записи создаёт команда платформы.',
    welcomeTitle: 'Задайте пароль',
    welcomeIntro: 'Для вас создана учётная запись. Задайте пароль, чтобы завершить настройку.',
    welcomeDone: 'Пароль задан. Войдите с ним.',
  },
  welcome: {
    title: 'Создайте рабочее пространство',
    intro: 'В рабочем пространстве живут ваши сайты, их формы и люди, которые с ними работают. Агентства обычно создают одно пространство и по проекту на каждый сайт клиента.',
    workspaceName: 'Название пространства',
    address: 'Адрес',
    addressHint: 'Строчные латинские буквы, цифры и дефисы. Используется в ссылках на панель.',
    timezone: 'Часовой пояс',
    create: 'Создать пространство',
    failed: 'Не удалось создать пространство.',
    another: 'Новое пространство',
    closedTitle: 'Пока нет рабочего пространства',
    closedIntro: 'Ваша учётная запись пока не входит ни в одно рабочее пространство. Пространства создаёт команда платформы — попросите добавить вас или попросите администратора пространства прислать приглашение.',
  },
  nav: {
    overview: 'Обзор',
    submissions: 'Заявки',
    projects: 'Проекты',
    channels: 'Каналы',
    members: 'Участники',
    settings: 'Настройки',
    workspace: 'Пространство',
    limited: 'Ваш доступ ограничен отдельными проектами.',
    suspended: 'Пространство приостановлено. Его формы не принимают заявки.',
  },
  roles: { owner: 'Владелец', admin: 'Администратор', member: 'Участник', viewer: 'Наблюдатель' },
  overview: {
    title: 'Обзор',
    last24h: 'Заявки за 24 часа',
    last7d: 'Заявки за 7 дней',
    spam7d: 'Отсеяно спама за 7 дней',
    failed: 'Уведомления с ошибкой',
    waiting: 'Уведомления в очереди',
    failedHint: 'Откройте заявку, чтобы увидеть причину и отправить ещё раз.',
    startTitle: 'Настройте первую форму',
    start1: 'Создайте проект для сайта и укажите адреса, с которых он открывается.',
    start2: 'Добавьте канал — почтовый ящик для уведомлений — и включите его для проекта.',
    start3: 'Создайте форму, вставьте её код на страницу и отправьте тестовую заявку.',
    recent: 'Последние заявки',
    seeAll: 'Все заявки',
    counts: 'Проектов: {projects} · форм: {forms} · каналов: {channels}',
  },
  submissions: {
    title: 'Заявки',
    search: 'Поиск по любому полю',
    project: 'Проект',
    form: 'Форма',
    allProjects: 'Все проекты',
    allForms: 'Все формы',
    received: 'Принятые',
    spam: 'Спам',
    when: 'Получено',
    from: 'От кого',
    summary: 'Содержание',
    notifications: 'Уведомления',
    empty: 'Заявок пока нет',
    emptyHint: 'Когда кто-нибудь отправит одну из ваших форм, заявка появится здесь.',
    emptyFiltered: 'По этим условиям ничего не найдено.',
    detailTitle: 'Заявка',
    fields: 'Что отправлено',
    extra: 'Прочие поля со страницы',
    context: 'Откуда пришла',
    page: 'Страница',
    ip: 'IP-адрес',
    browser: 'Браузер',
    captcha: 'CAPTCHA',
    captchaVerified: 'пройдена',
    captchaUnverified: 'не удалось проверить (провайдер недоступен)',
    spamReason: 'Отмечено как спам: {reason}',
    noDeliveries: 'К форме не привязан ни один канал, поэтому уведомление никому не отправлено.',
    resend: 'Отправить ещё раз',
    channelRetired: 'Канал удалён',
    channelRetiredHint: 'Этот канал остался в пространстве, из которого перенесён проект. История сохранена, но через него больше ничего не отправляется.',
    resent: 'Поставлено в очередь. Отправим через мгновение.',
    attempts: 'Попыток: {count}',
    nextAttempt: 'следующая {when}',
    sentAt: 'отправлено {when}',
    delete: 'Удалить заявку',
    deleteConfirm: 'Удалить заявку навсегда? Это действие нельзя отменить.',
    deleted: 'Удалено.',
  },
  delivery: { pending: 'Ожидает', sending: 'Отправляется', sent: 'Отправлено', dead: 'Ошибка', suppressed: 'Подавлено' },
  projects: {
    title: 'Проекты',
    intro: 'Один проект — один сайт. Настройки проекта действуют для всех его форм.',
    create: 'Новый проект',
    createTitle: 'Новый проект',
    name: 'Название проекта',
    nameHint: 'Обычно домен сайта, например example.com.',
    origins: 'Адреса, с которых открывается сайт',
    originsHint: 'По одному в строке, например https://example.com или https://*.example.com. Только страницы с этих адресов смогут отправлять формы.',
    forms: 'Форм: {count}',
    empty: 'Проектов пока нет',
    emptyHint: 'Создайте проект для первого сайта, формы которого хотите обрабатывать.',
    created: 'Проект создан.',
    delete: 'Удалить проект',
    deleteConfirm: 'Удалить проект «{name}» со всеми формами и заявками? Это действие нельзя отменить.',
    deleted: 'Проект удалён.',
    tabForms: 'Формы',
    tabSettings: 'Настройки',
    tabChannels: 'Каналы',
    channelsIntro: 'Каждая форма проекта уведомляет включённые здесь каналы. Форма может отключить канал или добавить свой.',
    noOrigins: 'Пока не разрешён ни один адрес, поэтому ни одна страница не сможет отправить формы проекта. Добавьте адрес сайта в настройках.',
  },
  forms: {
    create: 'Новая форма',
    createTitle: 'Новая форма',
    name: 'Название формы',
    template: 'Взять за основу',
    templates: { contact: 'Обратная связь — имя, почта, сообщение', callback: 'Заказ звонка — имя, телефон', newsletter: 'Подписка — только почта' },
    created: 'Форма создана.',
    empty: 'В проекте пока нет форм',
    emptyHint: 'Создайте форму и вставьте её код на страницу.',
    status: { active: 'Работает', paused: 'Приостановлена' },
    pause: 'Приостановить',
    resume: 'Возобновить',
    pausedNote: 'Приостановлена: форма отвечает «заявки не принимаются».',
    recent: 'За 30 дней: {count}',
    last: 'последняя {when}',
    key: 'Ключ формы',
    endpoint: 'Адрес отправки',
    tabInstall: 'Установка',
    tabFields: 'Поля',
    tabSettings: 'Настройки',
    tabChannels: 'Каналы',
    installIntro: 'Вставьте один из вариантов на страницу. Первый делает больше всего за вас.',
    snippetClient: 'Форма с нашим скриптом (рекомендуем)',
    snippetClientHint: 'Скрипт обновляет антиспам-токен, сколько бы страница ни была открыта, показывает CAPTCHA, повторяет отправку при коротком сбое и выводит сообщения. Разметка и стили остаются вашими — важны только атрибуты.',
    snippetHtml: 'Обычная HTML-форма',
    snippetFetch: 'JavaScript (fetch)',
    submissionsLink: 'Заявки этой формы',
    rename: 'Переименовать форму',
    renamed: 'Форма переименована.',
    delete: 'Удалить форму',
    deleteConfirm: 'Удалить форму «{name}» и её заявки? Страницы, которые продолжают на неё отправлять, получат «не найдено». Это действие нельзя отменить.',
    deleted: 'Форма удалена.',
    needVerified: 'Чтобы создать форму, подтвердите адрес почты.',
  },
  fields: {
    intro: 'Что принимает форма. Сохранение изменений создаёт новую версию; уже полученные заявки остаются с версией, по которой они проверялись.',
    version: 'Версия {version}',
    key: 'Ключ',
    keyHint: 'Атрибут name у поля ввода.',
    label: 'Подпись',
    type: 'Тип',
    required: 'Обязательное',
    role: 'Используется как',
    roleNone: '—',
    roles: { name: 'Имя отправителя', email: 'Почта отправителя (Reply-To)', phone: 'Телефон отправителя', message: 'Сообщение', consent: 'Согласие' },
    types: {
      text: 'Текст',
      textarea: 'Длинный текст',
      email: 'Почта',
      phone: 'Телефон',
      number: 'Число',
      select: 'Выбор',
      multiselect: 'Множественный выбор',
      checkbox: 'Флажок',
      consent: 'Согласие',
      date: 'Дата',
      url: 'Ссылка',
      hidden: 'Скрытое',
    },
    options: 'Варианты',
    optionsHint: 'По одному в строке.',
    maxLength: 'Макс. длина',
    phoneRegions: 'Страны',
    phoneRegionsHint: 'двухбуквенные коды в том порядке, в котором их пробовать',
    phoneRegionsPlaceholder: 'RU, KZ',
    phoneRegionsTried: 'Номер без кода страны читается как номер: {names} — по первой стране, где он верен.',
    phoneRegionsNone: 'Страны не указаны: принимаются только номера, начинающиеся с + и кода страны.',
    phoneRegionsUnknown: 'Не код страны: {codes}. Великобритания — GB.',
    phoneRegionsTooMany: 'Не больше {max} стран.',
    add: 'Добавить поле',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    saved: 'Поля сохранены, версия {version}.',
    unchanged: 'Ничего не изменилось.',
  },
  settings: {
    inherited: 'Наследуется',
    overridden: 'Переопределено',
    fromProject: 'из проекта',
    fromDefault: 'значение платформы',
    revert: 'Вернуть значение проекта',
    formIntro: 'Форма использует настройки проекта, пока вы не переопределите одну из них здесь.',
    allowedOrigins: 'Разрешённые адреса',
    allowedOriginsHint: 'По одному в строке. Страницы с этих адресов могут отправлять форму.',
    allowLocalhost: 'Разрешить localhost',
    allowLocalhostHint: 'Для разработки. На рабочем сайте выключите.',
    locale: 'Язык сообщений для посетителей',
    honeypot: 'Поле-ловушка',
    honeypotHint: 'Скрытое поле, которое заполняют только боты.',
    timingToken: 'Токен времени',
    timingTokenHint: 'Перед отправкой страница получает токен. Выключайте только для форм, которые должны работать без JavaScript.',
    minFillSeconds: 'Минимальное время заполнения, секунд',
    unknownFieldPolicy: 'Поля, которых нет в форме',
    unknownPolicies: { store_as_extra: 'Сохранять', ignore: 'Отбрасывать', reject: 'Отклонять заявку' },
    successUrl: 'Страница после отправки (без JavaScript)',
    errorUrl: 'Страница после ошибки (без JavaScript)',
    urlHint: 'Должна находиться на разрешённом адресе. Оставьте пустым, чтобы показать простое сообщение.',
    retentionDays: 'Хранить заявки, дней',
    retentionHint: 'Заявки старше этого срока удаляются, не позже чем через сутки; спам — через 14 дней или через этот срок, если он короче. Сокращение срока касается и уже сохранённых заявок, увеличение — только новых.',
    retentionShortenTitle: 'Сократить срок хранения?',
    retentionShortenProject: 'Заявки старше {days} дн. во всех формах, где действует срок проекта, будут удалены — обычно в течение часа. Восстановить их будет нельзя.',
    retentionShortenForm: 'Заявки этой формы старше {days} дн. будут удалены — обычно в течение часа. Восстановить их будет нельзя.',
    retentionShortenApply: 'Сократить и удалить',
    storeIp: 'Сохранять IP-адрес посетителя',
    groupAccess: 'Кто может отправлять форму',
    groupSpam: 'Защита от спама',
    groupBehaviour: 'Поведение',
    groupPrivacy: 'Приватность',
  },
  captcha: {
    title: 'CAPTCHA',
    intro: 'Проверка, что посетитель — человек, перед тем как форма будет принята. Ключи выдаёт провайдер.',
    inheritedIntro: 'Форма использует CAPTCHA проекта. Сохраните выбор здесь, чтобы задать форме свою.',
    useProject: 'Как в проекте',
    provider: 'Провайдер',
    providers: {
      none: 'Выключена',
      turnstile: 'Cloudflare Turnstile',
      recaptcha_v2: 'Google reCAPTCHA v2 (флажок)',
      recaptcha_v3: 'Google reCAPTCHA v3 (оценка, ничего не показывается)',
    },
    where: {
      turnstile: 'Создайте виджет в панели Cloudflare в разделе Turnstile и укажите там адрес сайта.',
      recaptcha_v2: 'Зарегистрируйте сайт в консоли Google reCAPTCHA с типом «v2 — Я не робот». Ключи другого типа не подойдут.',
      recaptcha_v3: 'Зарегистрируйте сайт в консоли Google reCAPTCHA с типом «v3 — на основе оценки». Ключи другого типа не подойдут.',
    },
    siteKey: 'Ключ сайта',
    siteKeyHint: 'Публичный: он есть на самой странице. Скопируйте его так, как его показывает провайдер.',
    secretKey: 'Секретный ключ',
    secretNew: 'Хранится в зашифрованном виде. Показать его снова нельзя, можно только заменить. Новому ключу сайта нужен свой секрет.',
    secretSaved: 'Секретный ключ сохранён. Оставьте поле пустым, чтобы не менять его, или введите новый.',
    minScore: 'Минимальная оценка',
    minScoreHint: 'От 0 (точно бот) до 1 (точно человек). Google советует 0,5.',
    saved: 'CAPTCHA сохранена. Формы начнут использовать её в течение полуминуты.',
  },
  channels: {
    title: 'Каналы',
    intro: 'Куда приходят уведомления. Создайте канал, затем включите его для проекта или формы.',
    create: 'Новый канал',
    createTitle: 'Новый почтовый канал',
    createWebhookTitle: 'Новый вебхук',
    editTitle: 'Изменение канала',
    type: 'Тип',
    types: { email: 'Электронная почта', webhook: 'Вебхук', bitrix24: 'Битрикс24' },
    noTypes: 'В этом пространстве пока не доступен ни один тип каналов. Попросите поддержку включить нужный.',
    webhookNameHint: 'Для вас, например «CRM».',
    createBitrix24Title: 'Новый канал Битрикс24',
    bitrix24NameHint: 'Для вас, например «Лиды в Битрикс24».',
    bitrix24Entity: 'Что создавать',
    bitrix24Entities: { lead: 'Лиды', deal: 'Сделки с контактом' },
    bitrix24EntityHint: {
      lead: 'Для CRM в классическом режиме, с лидами.',
      deal: 'Для CRM без лидов (простой режим) или чтобы обойтись без них: имя, e-mail и телефон попадут в новый контакт, привязанный к сделке.',
    },
    bitrix24EntityFixed: 'Выбирается при создании канала. Для другого варианта создайте ещё один канал.',
    bitrix24HowTitle: {
      lead: 'Каждая заявка становится лидом в вашем Битрикс24. Чтобы подключить:',
      deal: 'Каждая заявка становится сделкой в вашем Битрикс24, с контактом того, кто её отправил. Чтобы подключить:',
    },
    bitrix24Step1: 'В Битрикс24 откройте «Разработчикам» → «Другое» → «Входящий вебхук».',
    bitrix24Step2: 'Отметьте право «CRM (crm)» и сохраните.',
    bitrix24Step3: 'Скопируйте адрес из поля «Вебхук для вызова rest api» и вставьте ниже.',
    bitrix24Url: 'Адрес входящего вебхука',
    bitrix24UrlHint: 'Он работает как пароль к вашей CRM: мы проверим его сейчас, сохраним в зашифрованном виде и больше не покажем.',
    bitrix24UrlSaved: 'Сохранён. Вставляйте новый адрес, только чтобы заменить его: перед сохранением он будет проверен.',
    bitrix24Assigned: 'ID ответственного',
    bitrix24AssignedHint: 'Пользователь Битрикс24, на которого назначаются новые лиды и сделки, — число в адресе его профиля. Пусто — решает Битрикс24.',
    bitrix24Source: 'Источник',
    bitrix24SourceHint: 'Код источника из настроек CRM. WEB — это «Веб-сайт» в Битрикс24.',
    bitrix24Creates: { lead: 'Создаёт лиды', deal: 'Создаёт сделки' },
    bitrix24CreatesAssigned: { lead: 'Создаёт лиды · ответственный {user}', deal: 'Создаёт сделки · ответственный {user}' },
    bitrix24Mapped: 'Сопоставлено полей: {count}',
    mapping: {
      open: { lead: 'Сопоставление полей', deal: 'Воронка и поля' },
      title: { lead: 'Сопоставление полей — {name}', deal: 'Воронка и поля — {name}' },
      intro: {
        lead: 'В какое поле лида идёт каждое поле формы. Все поля по-прежнему попадают и в комментарий лида.',
        deal: 'В какую воронку идут сделки и в какое поле сделки идёт каждое поле формы. Все поля по-прежнему попадают и в комментарий сделки.',
      },
      pipeline: 'Воронка',
      pipelineDefault: 'Воронка по умолчанию',
      pipelineDefaultNamed: 'Воронка по умолчанию ({name})',
      pipelineHint: 'Новые сделки попадают на первую стадию воронки.',
      pipelineGone: 'Воронка {id}',
      pipelineMissing: 'На портале больше нет этой воронки, или пользователь вебхука её не видит. Выберите другую: пока она выбрана, Битрикс24 может отклонять сделки.',
      fetched: 'Поля прочитаны из {portal} {when}.',
      reading: 'Читаем поля портала…',
      stalled: 'Поля портала так и не пришли. Нажмите «Обновить поля», чтобы попробовать ещё раз.',
      never: 'Поля портала ещё не прочитаны.',
      failed: 'Не удалось прочитать поля: {message}',
      refresh: 'Обновить поля',
      fieldFor: { lead: 'Поле лида для «{field}»', deal: 'Поле сделки для «{field}»' },
      commentsOnly: '— Только в комментарии',
      standard: 'Поля Битрикс24',
      custom: 'Ваши поля',
      inForms: 'В формах: {forms}',
      noForm: 'Сейчас этого поля нет ни в одной форме; сопоставление сохранено.',
      missingTarget: 'На портале больше нет этого поля. При сохранении оно будет убрано.',
      automatic: {
        lead: { name: 'Само попадает в имя лида.', email: 'Само попадает в e-mail лида.', phone: 'Само попадает в телефон лида.' },
        deal: { name: 'Само попадает в имя контакта.', email: 'Само попадает в e-mail контакта.', phone: 'Само попадает в телефон контакта.' },
      },
      types: { string: 'текст', integer: 'целое число', double: 'число', boolean: 'да / нет', date: 'дата', datetime: 'дата и время', enumeration: 'список', url: 'ссылка' },
      multiple: 'несколько значений',
      values: 'Какому пункту списка соответствует каждый ответ:',
      valuesFree: 'Что посетитель пишет для каждого пункта списка:',
      itemFor: 'Пункт списка для «{value}»',
      answerFor: 'Ответ, означающий «{item}»',
      skip: '— Пропустить',
      noForms: 'В этом пространстве пока нет форм.',
      unmappable: {
        lead: 'Остальные поля лида — {count} шт.: деньги, файлы, пользователи, связи — не принимают значение из формы.',
        deal: 'Остальные поля сделки — {count} шт.: деньги, файлы, пользователи, связи, стадия — не принимают значение из формы.',
      },
      alwaysComments: {
        lead: 'Имя, e-mail, телефон, название, комментарий, источник и ответственного заполняет платформа.',
        deal: 'Название, комментарий, источник, ответственного и контакт заполняет платформа; имя, e-mail и телефон попадают в контакт.',
      },
      saved: { lead: 'Сопоставление сохранено.', deal: 'Воронка и поля сохранены.' },
    },
    url: 'Адрес',
    urlHint: 'Каждая заявка отправляется сюда в JSON методом POST. Адрес должен начинаться с https:// и быть доступен из интернета.',
    headers: 'Заголовки',
    headersHint: 'Отправляются с каждым вызовом, например ключ API, который ждёт ваш сервер. Значения хранятся в зашифрованном виде и больше не показываются.',
    headersLine: 'Заголовки: {names}',
    headerName: 'Название',
    headerValue: 'Значение',
    headerValueSaved: 'Сохранено — оставьте пустым, чтобы не менять',
    addHeader: 'Добавить заголовок',
    removeHeader: 'Убрать заголовок',
    signatureNote: 'Каждый вызов подписан: заголовок X-Formplat-Signature позволяет вашему серверу проверить, что вызов от нас и не изменён.',
    signingTitle: 'Секрет подписи',
    signingIntro: 'Скопируйте секрет подписи для «{name}» сейчас. Больше он показан не будет; если он потеряется, создайте новый.',
    signingHow: 'Ваш сервер проверяет им каждый вызов: HMAC-SHA256 от метки времени и тела сравнивается с заголовком X-Formplat-Signature. Готовый код есть в документации для разработчиков.',
    signingDone: 'Я скопировал секрет',
    rotate: 'Новый секрет подписи',
    rotateConfirm: 'Создать новый секрет подписи для «{name}»? Текущий будет работать ещё 24 часа, чтобы ваш сервер успел переключиться. Секрет, заменённый раньше, перестанет работать сразу.',
    previousUntil: 'Прежний секрет подписи работает до {when}.',
    name: 'Название канала',
    nameHint: 'Для вас, например «Почта отдела продаж».',
    recipients: 'Получатели',
    recipientsHint: 'По одному адресу в строке, не более 20.',
    subject: 'Тема письма',
    subjectHint: 'Подстановки вида {placeholder} заменяются отправленным значением. Оставьте пустым, чтобы использовать тему по умолчанию.',
    fromName: 'Имя отправителя',
    fromNameHint: 'Видно в почтовом ящике. Сам адрес принадлежит платформе.',
    empty: 'Каналов пока нет',
    emptyHint: 'Добавьте ящик, в который должны приходить заявки.',
    created: 'Канал создан.',
    deleted: 'Канал удалён.',
    deleteConfirm: 'Удалить канал «{name}»? Привязанные к нему формы перестанут его уведомлять.',
    health: { ok: 'Работает', unverified: 'Ещё не использовался', failing: 'Сбои' },
    lastOk: 'последняя доставка {when}',
    failures: 'Сбоев подряд: {count}',
    bind: 'Уведомлять этот канал',
    bound: 'Вкл.',
    off: 'Выкл.',
    inheritedOn: 'Вкл. (из проекта)',
    disabledHere: 'Отключён для этой формы',
    formOnly: 'Только для этой формы',
    formIntro: 'Каналы, включённые для проекта, действуют и здесь. Можно отключить канал для этой формы или добавить другой.',
    none: 'Сначала создайте канал в разделе «Каналы».',
    switchOffHere: 'Отключить для этой формы',
    switchOnHere: 'Включить для этой формы',
    inherit: 'Вернуть настройку проекта',
  },
  members: {
    title: 'Участники',
    intro: 'Люди, у которых есть доступ к этому пространству.',
    invite: 'Пригласить',
    inviteTitle: 'Приглашение участника',
    role: 'Роль',
    roleHints: {
      owner: 'Всё, включая удаление пространства.',
      admin: 'Всё, кроме передачи и удаления пространства.',
      member: 'Управляет проектами, формами и каналами; читает заявки.',
      viewer: 'Читает заявки и статусы доставки.',
    },
    invited: 'Приглашение отправлено на {email}.',
    pending: 'Приглашения, ожидающие ответа',
    expires: 'истекает {when}',
    cancelInvite: 'Отозвать',
    remove: 'Удалить из пространства',
    removeConfirm: 'Удалить {name} из этого пространства?',
    removed: 'Удалён.',
    joined: 'в пространстве с {when}',
    you: 'вы',
    access: 'Доступ',
    allProjects: 'Все проекты',
    someProjects: 'Проектов: {count}',
    limitTitle: 'Ограничение доступа проектами',
    limitIntro: 'Выберите проекты, которые видит {name}. Если не выбрано ни одного, доступно всё пространство.',
    inviteLimitHint: 'Выберите проекты, чтобы ограничить доступ. Если не выбрано ни одного, будет доступно всё пространство.',
    limitSaved: 'Доступ обновлён.',
    roleChanged: 'Роль изменена.',
  },
  workspace: {
    title: 'Настройки пространства',
    profile: 'Профиль',
    name: 'Название',
    locale: 'Язык уведомлений',
    timezone: 'Часовой пояс',
    timezoneHint: 'В нём показываются даты в панели, например Europe/Moscow.',
    region: 'Регион',
    regionHint: 'Где хранятся данные. Изменить нельзя.',
    account: 'Ваша учётная запись',
    sessions: 'Устройства, на которых выполнен вход',
    signOutOthers: 'Выйти на всех остальных устройствах',
    signedOutOthers: 'На остальных устройствах выполнен выход.',
    thisDevice: 'это устройство',
  },
};
